module.exports = __webpack_public_path__ + "h5/img/share-info.f8d82eae.png";